var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styles from './Styles.module.scss';
import { useForm } from "react-hook-form";
import ButtonSubmit from "./ButtonSubmit";
import { channelAPI } from "../../API/api";
import { useAppDispatch, useAppSelector } from "../../hooks/hook";
import { closeMenu, setSelectedChannel } from "../../store/slices/appSlice";
import { createObjectChannel } from "../../utils/utils";
import { useTypedTranslation } from "../../hooks/useTypedTranslation";
const OPEN = 'open';
const CLOSED = 'closed';
function defineTypeChannel(data) {
    if (data.isOpen === OPEN)
        return true;
    return false;
}
const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));
const NAME_REGEXP = /^[\p{L}0-9_*\s-]{4,20}$/u;
const CreateChannel = () => {
    const currentUser = useAppSelector(state => state.app.currentUser);
    const dispatch = useAppDispatch();
    const { t } = useTypedTranslation();
    const { register, handleSubmit, formState: { errors, isSubmitting }, reset, setError } = useForm({
        mode: 'onSubmit',
        defaultValues: {
            isOpen: OPEN
        }
    });
    const submit = (data) => __awaiter(void 0, void 0, void 0, function* () {
        const isFreeName = yield channelAPI.checkName(data.name);
        if (isFreeName) {
            const isOpen = defineTypeChannel(data);
            yield channelAPI.createChannel(currentUser, { displayName: data.name, isOpen })
                .then(((info) => {
                const chanelObj = createObjectChannel(info);
                dispatch(closeMenu());
                dispatch(setSelectedChannel(chanelObj));
            }));
        }
        else {
            setError('name', { message: t('errorRegName') });
        }
    });
    return (_jsxs("form", { className: styles.group, onSubmit: handleSubmit(submit), children: [_jsxs("div", { className: styles.item, children: [_jsx("input", Object.assign({ type: "text", placeholder: t('enterTheName') }, register('name', {
                        required: { value: true, message: t("form.required") },
                        minLength: { value: 4, message: t('form.min') },
                        maxLength: { value: 20, message: t('form.max') },
                        pattern: { value: NAME_REGEXP, message: t('form.chars') }
                    }))), _jsx("div", { className: styles.error, children: errors.name && _jsx("span", { children: errors.name.message }) })] }), _jsx("div", { className: styles.item, children: _jsxs("div", { className: styles.labelGroup, children: [_jsxs("label", { children: [_jsx("input", Object.assign({ type: "radio", name: "type", value: OPEN }, register('isOpen'))), t('open')] }), _jsxs("label", { children: [_jsx("input", Object.assign({ type: "radio", name: "type", value: CLOSED }, register('isOpen'))), t('closed')] })] }) }), _jsx("div", { className: styles.item, children: _jsx(ButtonSubmit, { isSubmitting: isSubmitting }) })] }));
};
export default CreateChannel;
